import axios from '@/libs/http'
import {appendIfNotEmpty} from "@/libs/util";

/**
 * 店员积分兑换记录
 */
export const pointsExchangeLogList = (action, status, pageNo, pageSize) => {
    let data = new URLSearchParams()
    appendIfNotEmpty(data, 'action', action)
    appendIfNotEmpty(data, 'status', status)
    data.append("pageNo", pageNo);
    data.append("pageSize", pageSize);
    return axios.request({
        url: '/s/c/clerk-points-exchange-log/list',
        data,
        method: 'post'
    })
}

